<style lang="less">

@import (reference) "../../../css/core/color.less";

.wx-toolbar {

	//覆盖element样式
	.el-input{width:150px;}
	.el-input__inner{border-color:@borderColor1;}
	.el-input__inner:focus{border-color:@color;}

	.el-select{width:150px;}
	.el-select .el-input{width:100%;}
	.el-cascader{width:100%;}
	.el-cascader .el-input{width:100%;}

	//自定义样式
	.wrap{
		display:flex;align-items:center;font-size:0;

		input,select,span{font-size:14px;}
	}
	.wrap > *{
		margin-right:5px;
	}
	.part-l > *{
		margin-right:5px;
	}
	.part-r > *{
		margin-left:5px;
	}
	.parts{flex:1;display:flex;align-items: center;justify-content: space-between;}
	.part-l,
	.part-r{
		display:inline-flex;align-items: center;
	}
}
</style>

<template>
<div class="wx-toolbar">
	<div class="wrap" v-if="!parts">
		<slot></slot>
	</div>
	<div class="wrap parts" v-if="parts">
		<div class="part-l"><slot name="partl"></slot></div>
		<div class="part-r"><slot name="partr"></slot></div>
	</div>
</div>
</template>

<script>
export default {
    props: {
        parts: {
			type: Boolean,
			default:false
        }
    }
};
</script>





// WEBPACK FOOTER //
// src/components/core/toolbar/Toolbar.vue